import React, { ChangeEvent } from 'react'
import { useTranslation } from 'react-i18next'
import { Box, Button, Combobox, Input } from '@node-space/ui-components'

export interface Search {
  placeholder: string
  value: string
  onChange: (value: string) => void
}

export interface Filter {
  id: string
  placeholder: string
  values: string[]
  checkedValues: string[]
  getLabel: (option: string) => string
  onFilterChange: (filterId: string, option: string) => void
}

export interface SearchAndFilterProps {
  search?: Search
  filters?: Filter[]
  testId: string
  onResetAll?: () => void
}

export const SearchAndFilter = ({ search, filters, testId, onResetAll }: SearchAndFilterProps) => {
  const { t } = useTranslation()
  return (
    <Box flex align="center" width="full" gap={12}>
      {search && (
        <Box paddingT={4} flexSize="fill">
          <Input
            placeholderText={search?.placeholder}
            value={search?.value}
            onChange={(event: ChangeEvent<HTMLInputElement>) =>
              search?.onChange(event?.target?.value)
            }
            searchable
            testId={`${testId}-search`}
          />
        </Box>
      )}
      {filters?.map(({ id, placeholder, values, checkedValues, getLabel, onFilterChange }) => (
        <Box key={id} className="w-[180px]">
          <Combobox
            checkedValues={checkedValues || []}
            onCheckedChange={value => onFilterChange(id, value)}
            id={id}
            selectPlaceholder={placeholder}
            filter={false}
            items={values?.map(value => ({
              leftText: getLabel(value),
              value,
            }))}
            testId={`${testId}-${id}`}
          />
        </Box>
      ))}
      {onResetAll && (
        <Box paddingT={4}>
          <Button variant="secondary" onClick={onResetAll}>
            {t('resetAll')}
          </Button>
        </Box>
      )}
    </Box>
  )
}
